module.exports = require('./lib/index')



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-hot-loader/index.js
// module id = 885
// module chunks = 0